<script lang="ts">
  import TablerBellRinging from '~icons/tabler/bell-ringing';
  import { priceAlertsDialog } from './PriceAlertsModal.svelte';

  function handleClick() {
    priceAlertsDialog.open();
  }
</script>

<button on:click|stopPropagation|preventDefault|capture={handleClick}>
  <TablerBellRinging
    class="mr-2 h-5 w-5 rounded-lg p-1 text-gray-900/70 hover:bg-gray-100/80 hover:text-gray-900"
  />
</button>
